var subscribe = function subscribe(subscriber) {
  document.addEventListener('show-global-alert', subscriber);
};

var unsubscribe = function unsubscribe(subscriber) {
  document.removeEventListener('show-global-alert', subscriber);
};

var show = function show(alert) {
  var event = document.createEvent('CustomEvent');
  event.initCustomEvent('show-global-alert', true, true, {
    alert: alert
  });
  document.dispatchEvent(event);
};

var callAlert = function callAlert(appearance) {
  return function (text, timeout) {
    return show({
      message: text,
      timeout: timeout,
      appearance: appearance
    });
  };
};

export default {
  subscribe: subscribe,
  unsubscribe: unsubscribe,
  success: callAlert('success'),
  info: callAlert('info'),
  warning: callAlert('warning'),
  critical: callAlert('critical')
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/@trustpilot/businessapp-patternlibrary/lib/components/GlobalAlert/GlobalAlertService.js
// module id = 825
// module chunks = 0